module.exports = __webpack_public_path__ + "img/panel10.b5d022a6.jpg";